import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  
  const updateConsent = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted'
      });
    }
  };

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'granted') {
      updateConsent();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'granted');
    setIsVisible(false);
    updateConsent();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'denied');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 flex flex-col lg:flex-row items-center justify-between gap-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
      <div className="text-sm md:text-base text-gray-200 text-center lg:text-left flex-1">
        Ez a weboldal statisztikai és marketing célú sütiket (cookie-kat) használ a felhasználói élmény javítása érdekében. Dönthetsz úgy, hogy csak a weboldal működéséhez elengedhetetlen sütiket engedélyezed.
      </div>
      <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto shrink-0 justify-center">
<button
          onClick={handleReject}
          className="whitespace-nowrap bg-transparent border-2 border-gray-500 hover:border-gray-400 hover:bg-gray-800 text-gray-300 px-6 py-2.5 rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          Csak a kötelezők elfogadása
        </button>
        <button
          onClick={handleAccept}
          className="whitespace-nowrap bg-teal-600 hover:bg-teal-500 text-white px-6 py-2.5 rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-offset-2 focus:ring-offset-gray-900"
        >
          Összes elfogadása
        </button>
      </div>
    </div>
  );
}
